import styled from "styled-components";

export const PricingCard = styled.div<{ isHighlighted?: boolean }>`
  display: flex;
  flex-direction: column;
  flex: 1;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid #e7ecee;
  border-radius: 0.8rem;
  overflow: hidden;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.08);
  min-height: min-content;
`;

export const PricingCardHeader = styled.div<{ isHighlighted?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  padding: 2.4rem;
  background: ${({ isHighlighted }) => (isHighlighted ? "#1d75bb" : "#f3f5fb")};
`;

export const PricingBadge = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 0.2rem 0.4rem;
  background: rgba(246, 146, 30, 0.85);
  border-radius: 1px;
  width: fit-content;
`;

export const PricingBadgeText = styled.span`
  font-family: "Roboto", sans-serif;
  font-weight: 900;
  font-size: 1rem;
  line-height: 1.2rem;
  letter-spacing: 0.03rem;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.white};
  opacity: 0.9;
`;

export const PricingCardTitle = styled.h2<{ isHighlighted?: boolean }>`
  font-family: "Roboto Slab", serif;
  font-weight: 700;
  font-size: 3.2rem;
  line-height: 4rem;
  letter-spacing: 0.03rem;
  color: ${({ isHighlighted }) => (isHighlighted ? "#ffffff" : "#272727")};
  margin: 0;
`;

export const PricingCardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  padding: 0 2.4rem;
  padding-bottom: 2.4rem;
`;

export const PriceSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  padding-bottom: 1.6rem;
`;

export const PriceWrapper = styled.div`
  display: flex;
  gap: 0.8rem;
  align-items: flex-start;
`;

export const PriceAmount = styled.span`
  font-family: "Roboto Slab", serif;
  font-weight: 400;
  font-size: 6.4rem;
  line-height: normal;
  color: #1d75bb;
`;

export const PriceCurrency = styled.span`
  font-family: "Roboto Slab", serif;
  font-weight: 400;
  font-size: 3.1rem;
  line-height: normal;
  color: #c0c0c0;
  height: 7.6rem;
  display: flex;
  align-items: center;
`;

export const CheckItem = styled.div`
  display: flex;
  gap: 0.4rem;
  align-items: center;
`;

export const CheckIcon = styled.div`
  width: 2.4rem;
  height: 2.4rem;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 2rem;
    height: 2rem;
  }
`;

export const CheckText = styled.span`
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  font-size: 1.2rem;
  line-height: 1.6rem;
  letter-spacing: 0.03rem;
  color: rgba(51, 51, 51, 0.7);
`;

export const PricingDescription = styled.p`
  font-family: "Roboto Slab", serif;
  font-weight: 700;
  font-size: 1.6rem;
  line-height: 2.4rem;
  letter-spacing: 0.03rem;
  color: #333333;
  margin: 0;
`;

export const IncludedSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
`;

export const IncludedTitle = styled.h4`
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  font-size: 1.4rem;
  line-height: 2.8rem;
  letter-spacing: 0.03rem;
  color: #333333;
  margin: 0;
`;

export const IncludedItem = styled.div<{ isDisabled?: boolean }>`
  display: flex;
  gap: 0.8rem;
  align-items: flex-start;
  padding-top: 0.4rem;
`;

export const IncludedBullet = styled.div<{ isDisabled?: boolean }>`
  width: 0.8rem;
  min-width: 0.8rem;
  height: 0.8rem;
  margin-top: 0.8rem;
  background: ${({ isDisabled }) => (isDisabled ? "#c0c0c0" : "#1d75bb")};
  border-radius: 50%;
`;

export const IncludedText = styled.span<{ isDisabled?: boolean }>`
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  font-size: 1.4rem;
  line-height: 2.5rem;
  letter-spacing: 0.03rem;
  color: ${({ isDisabled }) => (isDisabled ? "#c0c0c0" : "#272727")};
`;

export const PricingCardFooter = styled.div`
  display: flex;
  justify-content: center;
  padding: 1.6rem;
`;

export const PricingButton = styled.button<{ isHighlighted?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 5rem;
  padding: 1.1rem 3.2rem;
  border-radius: 9.99rem;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  font-size: 2rem;
  line-height: 2.4rem;
  letter-spacing: 0.02rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;

  ${({ isHighlighted, theme }) =>
    isHighlighted
      ? `
    background: #1b75bb;
    border: 2px solid #1d75bb;
    color: #fcfcfc;
    
    &:hover {
      background: #165d94;
    }
  `
      : `
    background: ${theme.colors.white};
    border: 2px solid rgba(186, 192, 194, 0.5);
    color: #1d75bb;
    
    &:hover {
      border-color: #1d75bb;
    }
  `}
`;
